// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import React, { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "./style.css";
import Header from './Header';
import useAuth from './useAuth';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://13.67.118.92:5000";
// 

function AutoJobsMenu() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { functions } = useAuth();
    const can = (key) => Array.isArray(functions) && functions.includes(key);

    return(
        <div>
            <Header />
            <div className="content">
                <main className="button-container">
                    <ul className="shadow-button-set">
                        {can('auto_jobs_sop_team') && (
                        <li>
                            <button onClick={() => navigate('/run-python-sop-team')}>{t('xJobs.sopTeam')}</button>
                        </li>
                        )}
                        {/* <li><button>Element #3</button></li>
                        <li><button>Element #4</button></li>
                        <li><button>Element #5</button></li> */}
                    </ul>
                </main>
            </div>
            <style jsx="true">{`
                .button-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                }
                .shadow-button-set {
                    margin: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 5vmin;
                
                    & > li {
                        display: inline-flex;
                        background: black;
                        width: 750px;
                        
                        &:is(:hover, :focus-within) > button:not(:active) {
                        --distance: -10px;
                        }
                    }
                
                    & button {
                        appearance: none;
                        outline: none;
                        font-size: 5vmin;
                        border: 3px solid black;
                        background: white;
                        width: 100%;
                        text-align: left;
                        padding: 20px 20px;
                        
                        --distance: 0;
                        transform: translateX(var(--distance)) translateY(var(--distance));
                    }
                }
                @media (max-width: 1024px) {
                    .shadow-button-set {
                        flex-direction: column;
                        align-items: center;
                        gap: 4vmin;
                    }

                    .shadow-button-set > li {
                        width: 100%;
                    }

                    .shadow-button-set button {
                        font-size: 3vmin;
                        padding: 10px 15px;
                    }
                }
                @media (max-width: 768px) {
                    .shadow-button-set {
                        gap: 4vmin;
                    }

                    .shadow-button-set > li {
                        width: 100%;
                    }

                    .shadow-button-set button {
                        font-size: 6vmin;
                        padding: 10px 15px;
                    }
                }
                @media (max-width: 480px) {
                    .shadow-button-set > li {
                        width: 100%; 
                    }
                    .shadow-button-set button {
                        font-size: 7vmin;
                        padding: 10px 15px;
                    }
                }
            `}</style>
        </div>
    )
}

export default AutoJobsMenu
